<template>
  <div>

    <div class="form_box">
      <el-table empty-text="暂无数据" :data="tableData" border>
        <el-table-column label="报案用户" min-width="50">
          <template slot-scope="scope">
            {{scope.row.obj.obj.reportUser}}
          </template>
        </el-table-column>
        <el-table-column label="用户手机号" min-width="50">
          <template slot-scope="scope">
            {{scope.row.obj.obj.reporterContact}}
          </template>
        </el-table-column>
        <el-table-column label="报案时间" min-width="50">
          <template slot-scope="scope">
            {{setTime(scope.row.obj.obj.reportTs)}}
          </template>
        </el-table-column>
        <el-table-column prop="chuxianer" label="出险人" min-width="50">
          <template slot-scope="scope">
            {{scope.row.obj.victimList[0].obj.victimName}}
          </template>
        </el-table-column>
        <el-table-column prop="place" label="出险地" min-width="50">
          <template slot-scope="scope">
            {{setTxt(scope.row.obj.generalLocation.addr)}}
          </template>
        </el-table-column>
        <el-table-column  label="出险人保障" min-width="50">
          <template slot-scope="scope">
            {{statusObj[scope.row.obj.obj.caseInsured]}}
          </template>
        </el-table-column>
        <el-table-column prop="source" label="案件来源" min-width="50">
          <template slot-scope="scope">
            {{scope.row.obj.obj.caseSrc}}
          </template>
        </el-table-column>
        <el-table-column prop="op" label="操作" min-width="100">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="tores(scope.row.obj,1)">通过</el-button>
            <el-button type="text" size="small" @click="tores(scope.row.obj,2)">不通过</el-button>
            <el-button v-if="userType == 5" type="text" size="small" @click="dialogFormVisible2=true;caseId=scope.row.obj">关闭星使派单</el-button>
            <el-button v-if="userType == 5 || userType == 4" type='text' @click="openWork(scope.row.obj.obj.id)">加入协调</el-button>
            <el-button type="text" size="small">
              <router-link :to="{path:'/branch/starindex/starsdetail',query:{typeId:600,id:scope.row.obj.obj.id}}">案件详情</router-link>
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
		<el-dialog :title="title" center :visible.sync="dialogFormVisible1" width="500px">
			<center>是否确认{{title}}？</center>
			<div slot="footer" class="dialog-footer">
				<el-button @click="dialogFormVisible1 = false">取 消</el-button>
				<el-button type="primary" @click="deleteApply()">确 定</el-button>
			</div>
		</el-dialog>
    <el-dialog title="关闭星使派单" center :visible.sync="dialogFormVisible2" width="500px">
			<center>是否确认关闭？</center>
			<div slot="footer" class="dialog-footer">
				<el-button @click="dialogFormVisible2 = false">取 消</el-button>
				<el-button type="primary" @click="closeCase()">确 定</el-button>
			</div>
		</el-dialog>
  </div>
</template>

<script>
  import { xsApproveLst,authorize,closeCase,joinCoord } from '@/views/axios/api.js'
  import constants from '@/util/constants.js';
  export default {
    data() {
      return {
        tableData: [],
        dialogFormVisible1:false,
        dialogFormVisible2:false,
        token:JSON.parse(window.localStorage.getItem("data")).data,
        caseId:'',
        title:'',
        actionIndex:'',
        userType:JSON.parse(window.localStorage.getItem("insti")).type,
        statusObj:['在保','无保','在保','旅责险']
      }
    },
    components: {},
    methods: {
		setTxt(str, status) {
			if (constants.setTxt(str, status)) {
				return constants.setTxt(str, status);
			} else {
				return str;
			}
		},
      setTime(str) {
        return constants.time(str)
      },
      getData() {
        xsApproveLst({
            token: this.token
          })
          .then(res => {
            console.log(res);
            this.tableData = res.data.obj
          })
          .catch(err => {
            console.log(err);
          })
      },
      tores(obj,index){
        this.caseId=obj;
        this.dialogFormVisible1=true;
        if(index == 1){
          this.title='通过';
          this.actionIndex=1
        }else if(index == 2){
          this.title='不通过'
          this.actionIndex=2
        }else if(index == 3){
          this.title='关闭星使派单'
        }
      },
     deleteApply(){
       var action=''
       if(this.caseId.obj.caseState == 210 || this.caseId.obj.caseState == 230){ //分公司
         if(this.actionIndex == 1){
           action=0
         }else{
           action=1
         }
       }else{
         if(this.actionIndex == 1){
           action=2
         }else{
           action=3
         }
       }
        var data={
          token:this.token,
          caseId:this.caseId.obj.id,
          action
        }
        authorize(data)
        .then(res => {
          console.log(res);
          if(res.data.code == 0){
            this.$message.success('操作成功')
            this.getData();
            this.dialogFormVisible1=false
          }
        })
        .catch(err => {
          console.log(err);
        })
     },
      closeCase(){
        console.log(this.caseId)
        var data={
          token:this.token,
          caseId:this.caseId.obj.id
        }
        closeCase(data)
        .then(res => {
          console.log(res);
          if(res.data.code == 0){
            this.$message.success('案件已关闭')
            this.getData()
            this.dialogFormVisible2=false
          }
        })
        .catch(err => {
          console.log(err);
        })
      },
      openWork(caseId) {
        joinCoord({token:this.token,caseId},'')
        .then(res => {
          console.log(res);
        })
        .catch(err => {
          console.log(err);
        })
        this.$store.commit('caseIdFun', caseId);
        this.$store.commit('workBtnFun', true);
      }
    },
    mounted() {
      this.getData();
    }
  };
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/cmd_center/star/shenhezhongList.vue